import {useTranslations} from 'next-intl';

const useComplianceTabItems = () => {
  const t = useTranslations('legal.tabs.compliance');

  return [
    {
      text: t('dsaNotice'),
      value: 'dsa-notice',
      child: false,
      routerPushUrl: '/legal/compliance?tab=dsa-notice'
    },
    {
      text: t('modernSlavery'),
      value: 'modern-slavery',
      child: false,
      routerPushUrl: '/modern-slavery-statement'
    },
    {
      text: t('webAccessibility'),
      value: 'web-accessibility',
      child: false,
      routerPushUrl: '/web-accessibility-statement'
    }
  ];
};

export default useComplianceTabItems;
